import React, { useState } from "react";

// Configuration data for repertoire information
const repertoireData = {
  violin: [
    {
      ageRange: [8, 10],
      title: "Age Group 8-10 (Violin)",
      pieces: [
        "Required Pieces (Suzuki Book No. 2)",
        "Chorus from 'Judas Maccabaeus' — G. F. Handel",
        "Musette — J. S. Bach",
        "Hunters' Chorus — C. M. von Weber",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Age Group 11-14 (Violin)",
      pieces: [
        "Rieding — Violin Concerto No. 2, Op. 35",
        "Seitz — Student Concerto No. 5",
        "Vivaldi — Concerto in A Minor, RV 356 (1st Movement)",
      ],
    },
    {
      ageRange: [15, 20],
      title: "Age Group 15-20 (Violin)",
      pieces: [
        "Bach — Concerto in A Minor, BWV 1041",
        "Accolay — Violin Concerto No. 2 in A Minor",
        "Mozart — Violin Concerto No. 3 in G Major, K.216",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Age Group 21+ (Violin)",
      pieces: [
        "Bruch — Violin Concerto No. 1 in G Minor, Op. 26",
        "Mendelssohn — Violin Concerto in E Minor, Op. 64",
        "Saint-Saëns — Violin Concerto No. 3 in B Minor, Op. 61",
      ],
    },
  ],
  viola: [
    {
      ageRange: [8, 10],
      title: "Age Group 8-10 (Viola)",
      pieces: [
        "Oskar Rieding – Concerto in E Minor, Op. 35",
        "Seitz – Concerto No. 5, 1st Movement (No. 2 from Suzuki Viola Book 4)",
        "Telemann – Concerto in G, 1st Movement (from Suzuki Viola Book 4)",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Age Group 11-14 (Viola)",
      pieces: [
        "Sonata in G Minor – 4th Movement (No. 3 from Suzuki Viola Book 5)",
        "Veracini – Gigue (No. 5 from Suzuki Viola Book 5)",
        "Seitz – Concerto No. 3 in C Minor (No. 9 from Suzuki Viola Book 5)",
      ],
    },
    {
      ageRange: [15, 20],
      title: "Age Group 15-20 (Viola)",
      pieces: [
        "F.A. Hoffmeister – Viola Concerto in D Minor, 1st Allegro with Cadenza",
        "Bach/Casadesus – Concerto for Viola in C Minor",
        "Handel/Casadesus – Viola Concerto, 1st Movement",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Age Group 21+ (Viola)",
      pieces: [
        "Vivaldi's Four Seasons for Viola",
        "Stamitz – Viola Concerto in D Minor, Op. 1, 1st Movement: Risoluto",
        "Vanhal – Viola Concerto in C Major",
      ],
    },
  ],
  cello: [
    {
      ageRange: [8, 10],
      title: "Age Group 8-10 (Cello)",
      pieces: [
        "F. Seitz – Concerto No. 5, 1st Movement",
        "C. Webster – Scherzo (from Suzuki Cello Book 3)",
        "Vivaldi – Cello Concerto in C Major, RV 399",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Age Group 11-14 (Cello)",
      pieces: [
        "J. B. Bréval – Sonata in C Major, Allegro",
        "Bach – Cello Suite No. 1 in G Major",
        "Goltermann – Rondo: Allegro Molto ",
      ],
    },
    {
      ageRange: [15, 21],
      title: "Age Group 15-21 (Cello)",
      pieces: [
        "Elgar – Cello Concerto",
        "Haydn – Concerto No. 1 in C Major, Hob. VIIb:1",
        "Jean Baptiste Bréval – Rondo from Concerto No. 2 in D Major",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Age Group 21+ (Cello)",
      pieces: [
        "Dvořák – Cello Concerto",
        "Schumann – Cello Concerto, Op. 129",
        "Barber – Cello Concerto",
      ],
    },
  ],
  trumpet: [
    {
      ageRange: [8, 10],
      title: "Age Group 8-10 (Trumpet)",
      pieces: [
        "When the Saints Go Marching In",
        "The Beautiful Snow – from the Arban Trumpet Method",
        "Jean-Baptiste Arban – Variations on The Carnival of Venice (1st Movement only)",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Age Group 11-14 (Trumpet)",
      pieces: [
        "Arban – Characteristic Study No. 1",
        "Jean-Baptiste Arban – Fantasie Brillante (1st Mov) ",
        "Joseph Haydn – Trumpet Concerto (1st Mov)",
      ],
    },
    {
      ageRange: [15, 21],
      title: "Age Group 15-21 (Trumpet)",
      pieces: [
        "Johann Hummel – Trumpet Concerto (1st Mov)",
        "Cascade",
        "Alexander Arutunian – Trumpet Concerto (1st Mov)",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Age Group 21+ (Trumpet)",
      pieces: [
        "Oscar Böhme – Trumpet Concerto in F Minor, Op. 18",
        "Henri Tomasi – Trumpet Concerto",
        "André Jolivet – Concerto for Trumpet",
      ],
    },
  ],
  trombone: [
    {
      ageRange: [8, 10],
      title: "Age Group 8-10 (Trombone)",
      pieces: [
        "When the Saints Go Marching In",
        "The Beautiful Snow – from the Arban Trombone Method",
        "Variations on Twinkle Twinkle Little Star (Simplified Version)",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Age Group 11-14 (Trombone)",
      pieces: [
        "Arban – Characteristic Study No. 1 (Trombone Adaptation)",
        "Arban – Fantasie Brillante (up to the final variation)",
        "Galliard – Sonata No. 1 in A Minor (1st or 2nd Movement)",
        "Larsson – Concertino for Trombone, Op. 45 No. 7 (1st Movement)",
      ],
    },
    {
      ageRange: [15, 21],
      title: "Age Group 15-21 (Trombone)",
      pieces: [
        "Ferdinand David – Concertino for Trombone, Op. 4",
        "Camille Saint-Saëns – Cavatine, Op. 144",
        "Launy Grøndahl – Trombone Concerto",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Age Group 21+ (Trombone)",
      pieces: [
        "Henri Tomasi – Trombone Concerto",
        "Nino Rota – Trombone Concerto",
        "Derek Bourgeois – Trombone Concerto",
      ],
    },
  ],
  tuba: [
    {
      ageRange: [8, 10],
      title: "Age Group 8-10 (Tuba)",
      pieces: [
        "When the Saints Go Marching In",
        "The Beautiful Snow – from the Arban Tuba Method (or similar lyrical etude)",
        "Variations on Twinkle Twinkle Little Star (Simplified Version)",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Age Group 11-14 (Tuba)",
      pieces: [
        "Arban – Characteristic Study No. 1 (Tuba Adaptation)",
        "Haddad – Suite for Tuba (1st or 2nd Movement)",
        "Capuzzi – Andante and Rondo (arranged for Tuba)",
        "Marcello – Sonata in F (1st and 2nd Movements)",
      ],
    },
    {
      ageRange: [15, 21],
      title: "Age Group 15-21 (Tuba)",
      pieces: [
        "Ralph Vaughan Williams – Concerto for Bass Tuba",
        "Edward Gregson – Tuba Concerto",
        "Lebedev – Concerto in One Movement",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Age Group 21+ (Tuba)",
      pieces: [
        "John Williams – Tuba Concerto",
        "Bruce Broughton – Tuba Concerto",
        "Krzysztof Penderecki – Capriccio for Tuba and Orchestra",
      ],
    },
  ],
  "double bass": [
    {
      ageRange: [8, 10],
      title: "Nivel 8 a 10 (Double Bass)",
      pieces: [
        "Gavotte – Suzuki Bass Book 3",
        "Minuet No. 2 – Suzuki Bass Book 3",
        "Antonín Dvořák – Humoresque (arranged for bass)",
        "J.S. Bach – Minuet in G (Suzuki-style)",
        "Henry Purcell – Rigadoon (arranged for bass)",
      ],
    },
    {
      ageRange: [11, 15],
      title: "Nivel 11 a 15 (Double Bass)",
      pieces: [
        "Tambourin – Suzuki Bass Book 5",
        "Keyper – Romance and Rondo (technically engaging, elegant Classical style)",
        "Capuzzi – Double Bass Concerto in F Major (Suzuki Book 5)",
        "Telemann – Sonata in A Minor, 2nd Movement: Allegro",
      ],
    },
    {
      ageRange: [16, 21],
      title: "Nivel 16 a 21 (Double Bass)",
      pieces: [
        "Giovanni Bottesini – Elegy",
        "František Hertl – Sonata for Double Bass and Piano",
        "Keyper – Romance and Rondo ",
        "Reinhold Glière – Intermezzo and Tarantella",
        "Adolf Mišek – Sonata No. 2 in E Minor ",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Nivel 21+ (Double Bass)",
      pieces: [
        "Giovanni Bottesini – Tarantella or Concertos No. 1 or 2",
        "Serge Koussevitzky – Humoresque, Op. 4",
        "Serge Koussevitzky – Double Bass Concerto in F♯ Minor",
        "Hans Fryba – Suite in the Olden Style",
        "Frank Proto – A Carmen Fantasy",
      ],
    },
  ],
  oboe: [
    {
      ageRange: [8, 10],
      title: "Nivel 8 a 10 (Oboe)",
      pieces: [
        "Jean-Baptiste Loeillet – Gavotte",
        "James Hook – Minuet in G",
        "Alessandro Marcello – Concierto en Re menor (1er movimiento)",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Nivel 11 a 14 (Oboe)",
      pieces: [
        "Georg Philipp Telemann – Fantasie Nº 1 en La Mayor",
        "Camille Saint-Saëns – Sonata para oboe, Op. 166 (1er movimiento)",
        "Franz Wilhelm Ferling – 48 Estudios para oboe, Op. 31 (estudios intermedios)",
      ],
    },
    {
      ageRange: [15, 21],
      title: "Nivel 15 a 21 (Oboe)",
      pieces: [
        "Josef Fiala – Concierto para oboe en Si bemol mayor",
        "Francis Poulenc – Sonata para oboe y piano",
        "Benjamin Britten – Six Metamorphoses after Ovid, Op. 49",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Nivel 21 en adelante (Oboe)",
      pieces: [
        "Richard Strauss – Concierto para oboe en Re mayor",
        "Bohuslav Martinů – Concierto para oboe y pequeña orquesta",
        "Eugène Bozza – Fantaisie Pastorale o Concierto para oboe y cuerdas",
      ],
    },
  ],
  flute: [
    {
      ageRange: [8, 10],
      title: "Nivel 8 a 10 (Flute)",
      pieces: [
        "Wilhelm Popp – Little Melody, Op. 384",
        "Giuseppe Gariboldi – Étude Mélodique, Op. 132 No. 1",
        "Jean-Louis Tulou – Petite Étude (from Méthode de flûte)",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Nivel 11 a 14 (Flute)",
      pieces: [
        "Georg Philipp Telemann – Sonata in F Major, I. Vivace",
        "Paul Taffanel – Andante Pastoral et Scherzettino",
        "Johann Sebastian Bach – Sonata en Do mayor, BWV 1033 (1er movimiento)",
      ],
    },
    {
      ageRange: [15, 21],
      title: "Nivel 15 a 21 (Flute)",
      pieces: [
        "Wolfgang Amadeus Mozart – Concierto para flauta en Re mayor, K. 313 (1er movimiento)",
        "Carl Philipp Emanuel Bach – Sonata en Re menor, H. 514 (1er movimiento)",
        "Philippe Gaubert – Nocturne et Allegro Scherzando",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Nivel 21 en adelante (Flute)",
      pieces: [
        "Francis Poulenc – Sonata para flauta y piano",
        "Georges Enesco – Concertstück para flauta y orquesta",
        "Carl Reinecke – Concerto in D Major, Op. 283",
      ],
    },
  ],
  clarinet: [
    {
      ageRange: [8, 10],
      title: "Nivel 8 a 10 (Clarinet)",
      pieces: [
        "Carl Baermann – Vocalise, Op. 63 No. 3",
        "Gustav Langenus – First Solo (from First Solo Album for Clarinet)",
        "James Rae – Easy Study No. 3 (from 18 Concert Studies for Clarinet)",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Nivel 11 a 14 (Clarinet)",
      pieces: [
        "Carl Baermann – Clarinet Method, Book 3 (selected progressive pieces)",
        "Carl Stamitz – Concerto No. 3 in B-flat Major (1er movimiento)",
        "Fritz Kreisler – Liebesfreud (arr. para clarinete)",
      ],
    },
    {
      ageRange: [15, 21],
      title: "Nivel 15 a 21 (Clarinet)",
      pieces: [
        "Carl Maria von Weber – Concertino for Clarinet, Op. 26",
        "Camille Saint-Saëns – Sonata para clarinete y piano, Op. 167",
        "Paul Jeanjean – Arabesques",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Nivel 21 en adelante (Clarinet)",
      pieces: [
        "Carl Nielsen – Clarinet Concerto",
        "Johannes Brahms – Sonata para clarinete en Fa menor, Op. 120 No. 1",
        "Henri Tomasi – Clarinet Concerto",
      ],
    },
  ],
  bassoon: [
    {
      ageRange: [8, 10],
      title: "Nivel 8 a 10 (Bassoon)",
      pieces: [
        "Ludwig Milde – Study No. 1, from 25 Studies in Scales and Chords, Op. 24",
        "Julius Weissenborn – Study No. 6, from Practical Method for Bassoon, Op. 8 Part I",
        "Julius Weissenborn – Study No. 1, from Practical Method for Bassoon, Op. 8 Part I",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Nivel 11 a 14 (Bassoon)",
      pieces: [
        "Ferdinand David – Concertino, Op. 12",
        "Ludwig Milde – Concert Studies, Op. 26 No. 1",
        "Joseph Bodin de Boismortier – Sonata in A minor, Op. 14 No. 5 (1er movimiento)",
      ],
    },
    {
      ageRange: [15, 21],
      title: "Nivel 15 a 21 (Bassoon)",
      pieces: [
        "Carl Maria von Weber – Andante e Rondo Ungarese, Op. 35",
        "Camille Saint-Saëns – Sonata para fagot y piano, Op. 168",
        "Georg Philipp Telemann – Sonata in F Minor, IV. Vivace",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Nivel 21 en adelante (Bassoon)",
      pieces: [
        "Wolfgang Amadeus Mozart – Concierto para fagot en Si bemol mayor, K. 191",
        "André Jolivet – Concerto pour basson et orchestre à cordes",
        "Paul Hindemith – Sonata para fagot y piano",
      ],
    },
  ],
  piano: [
    {
      ageRange: [8, 10],
      title: "Nivel 8 a 10 (Piano)",
      pieces: [
        "Johann Sebastian Bach – Minuet in G Major, BWV Anh. 114",
        "Ludwig van Beethoven – Ecossaise in G Major, WoO 23",
        "Cornelius Gurlitt – Album for the Young, Op. 140 No. 3",
      ],
    },
    {
      ageRange: [11, 14],
      title: "Nivel 11 a 14 (Piano)",
      pieces: [
        "Friedrich Burgmüller – Arabesque, Op. 100 No. 2",
        "Robert Schumann – The Wild Horseman, Op. 68 No. 8",
        "Dmitri Kabalevsky – Clowns, Op. 39 No. 20",
      ],
    },
    {
      ageRange: [15, 21],
      title: "Nivel 15 a 21 (Piano)",
      pieces: [
        "Ludwig van Beethoven – Sonatina in G Major, Anh. 5 No. 1",
        "Frédéric Chopin – Waltz in A Minor, B. 150",
        "Erik Satie – Gymnopédie No. 1",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Nivel 21 en adelante (Piano)",
      pieces: [
        "Ludwig van Beethoven – Sonata No. 14 “Claro de Luna” (Moonlight), Op. 27 No. 2",
        "Frédéric Chopin – Nocturne in E-flat Major, Op. 9 No. 2",
        "Claude Debussy – Clair de Lune, from Suite Bergamasque",
      ],
    },
  ],
  "french horn": [
    {
      ageRange: [8, 10],
      title: "Nivel 8 a 10 (French Horn)",
      pieces: [
        "Russian Dance – Kopprasch / Poole",
        "Nocturne, Op. 35, No. 10 – Gliere",
        "Pavane Pour Infante Défunte – Ravel / Dishinger",
        "Allerseelen – Strauss / Voxman",
      ],
    },
    {
      ageRange: [11, 15],
      title: "Nivel 11 a 15 (French Horn)",
      pieces: [
        "Nocturno, Op. 7 – Strauss, F.",
        "Concerto No. 2 in E♭ (mvt. 2) – Strauss, R.",
        "Concerto No. 2, K. 417 (1st mvt.) – Mozart",
        "Concerto No. 3, K. 447 (1st mvt.) – Mozart",
        "Concerto No. 4, K. 495 (1st mvt.) – Mozart",
      ],
    },
    {
      ageRange: [16, 21],
      title: "Nivel 16 a 21 (French Horn)",
      pieces: [
        "Hunter’s Moon – Vinter, G.",
        "Concerto No. 1 in E♭, Op. 11 (mvt. 1 or 2 & 3) – Strauss",
        "Morceau De Concert – Saint Saens",
        "Concertpiece, Op. 94 – Saint Saens",
        "Laudatio (unaccompanied) – Krol, Bernhard",
        "Sonata for Horn and Piano – Heiden, Bernhard",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Nivel 21 en adelante (French Horn)",
      pieces: [
        "Adagio and Allegro, Op. 70 – Schumann",
        "Concerto in B♭ Major, Op. 91 (Any Mvt.) – Gliere / Polekh",
        "Villanelle – Dukas",
        "Parable VIII, Op. 120 (unaccompanied) – Persichetti, Vincent",
        "Horn Call (Horn-Lokk) – Berge, Sigurd (unaccompanied)",
      ],
    },
  ],
  "percusión / teclados": [
    {
      ageRange: [8, 10],
      title: "Nivel 8 a 10 (Percusión / Teclados)",
      pieces: [
        "Ayodhya Vasi Ram",
        "The Juggler – George Hamilton Green",
        "El vuelo del abejorro – Nikolái Rimski-Kórsakov",
      ],
    },
    {
      ageRange: [11, 15],
      title: "Nivel 11 a 15 (Percusión / Teclados)",
      pieces: [
        "Concierto en La menor – Antonio Vivaldi",
        "Cuarto movimiento de la Sinfonía No. 4 – Piotr Ilich Chaikovski (redoblante)",
        "El vuelo del abejorro – Nikolái Rimski-Kórsakov",
      ],
    },
    {
      ageRange: [16, 21],
      title: "Nivel 16 a 21 (Percusión / Teclados)",
      pieces: [
        "The Solo Snare Drummer, Lección N.º 2 – Vic Firth",
        "Hungarian Dance No. 5 – Johannes Brahms",
        "Concierto para violín en La menor – Johann Sebastian Bach (adaptación para xilófono, 1er movimiento)",
      ],
    },
    {
      ageRange: [21, Infinity],
      title: "Nivel 21 en adelante (Percusión / Teclados)",
      pieces: [
        "Ragtime Potpourri: The Golden Age of the Xylophone",
        "Whispering Rivers – Elliott Fogo",
        "Etude in E Minor – Casey Cangelosi",
        "Children’s Corner – Claude Debussy",
      ],
    },
  ],
};

const MusicCompetition = () => {
  const [instrument, setInstrument] = useState("");

  // Renders all age groups and their pieces for the selected instrument
  const renderAllGroups = () => {
    if (!instrument) {
      return (
        <p className="text-gray-200 mt-4">
          Please select an instrument to see its repertoire.
        </p>
      );
    }

    const instrumentKey = instrument.toLowerCase();
    const groups = repertoireData[instrumentKey];

    if (!groups) {
      return (
        <p className="text-red-400 mt-4">
          We do not have repertoire data for “{instrument}.” Please choose another instrument.
        </p>
      );
    }

    return groups.map((group, idx) => (
      <div key={idx} className="bg-gray-700 p-4 rounded-md mb-4 shadow">
        <h3 className="text-xl font-bold text-yellow-300 mb-2">{group.title}</h3>
        <ul className="list-disc pl-6 text-gray-200">
          {group.pieces.map((piece, index) => (
            <li key={index}>{piece}</li>
          ))}
        </ul>
      </div>
    ));
  };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-6">
      <div className="max-w-4xl mx-auto bg-gray-800 p-6 rounded-md shadow-md">
        <h2 className="text-3xl font-serif font-bold text-yellow-400 mb-4">
          Music Competition Requirements
        </h2>
        <p className="mb-6 text-gray-200 leading-relaxed">
          Below you’ll find the required repertoire for each instrument organized by age group. Select an instrument from the dropdown and all the corresponding age groups will be displayed.
          <br />
          <span className="italic text-sm">
            Note: If you are younger, you may choose to play pieces from your age group or from a higher age group—but not from a lower age group.
          </span>
        </p>
        <div className="mb-6">
          <label className="block mb-2 font-medium text-gray-200">
            Select Your Instrument:
          </label>
          <select
            value={instrument}
            onChange={(e) => setInstrument(e.target.value)}
            className="block w-full mb-4 bg-gray-700 text-gray-200 border border-gray-600 p-2 rounded-md focus:ring-yellow-500 focus:border-yellow-500"
          >
            <option value="">-- Select an Instrument --</option>
            <option value="Violin">Violin</option>
            <option value="Viola">Viola</option>
            <option value="Cello">Cello</option>
            <option value="Trumpet">Trumpet</option>
            <option value="Trombone">Trombone</option>
            <option value="Tuba">Tuba</option>
            <option value="Double Bass">Double Bass</option>
            <option value="Flute">Flute</option>
            <option value="Oboe">Oboe</option>
            <option value="Clarinet">Clarinet</option>
            <option value="Bassoon">Bassoon</option>
            <option value="Piano">Piano</option>
            <option value="French Horn">French Horn</option>
            <option value="Percusión / Teclados">Percusión / Teclados</option>
          </select>
        </div>
        {renderAllGroups()}
      </div>
    </div>
  );
};

export default MusicCompetition;
